module.exports = __webpack_public_path__ + "static/img/b01.ea48d8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/b01.png
// module id = 0Ebt
// module chunks = 0